import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  text: "",
  type: "",
  isVisible: false,
  nonce: 0,
  duration: null,
}

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    showAlert(state, action) {
      const { text, type, duration } = action.payload
      state.text = text
      state.type = type
      // Optional per-alert display duration in ms — lets an unusually
      // important message (e.g. session-replaced) stay up longer than the
      // default toast timer. null/undefined means "use SweatAlert's default".
      state.duration = duration || null
      state.isVisible = true
      // Incremented on every dispatch so consumers (e.g. SweatAlert's effect)
      // re-fire even when the same text/type is shown again back-to-back.
      state.nonce += 1
    },
    hideAlert(state) {
      state.isVisible = false
    },
  },
})

export const { showAlert, hideAlert } = alertSlice.actions

export default alertSlice.reducer
